import React, { useMemo } from "react";

import DashboardWidgetCard from "./components/DashboardWidgetCard";
import DashboardCardHeader from "./components/DashboardCardHeader";
import HeaderAndValue from "./components/HeaderAndValue";

import { makeStyles } from "@material-ui/core";
import useFetch from "./hooks/useFetch";
import Loading from "./components/Loading";
import { formatDate, formatToCommaString } from "./helper/format";
import ToggleButtonsTrasnferList from "./components/ToggleButton";

const calculateToPercentage = (deno, neu) => {
  if (!deno) return "-";

  return `(${((neu * 100.0) / deno).toFixed(2)}%)`;
};

const config = (data) => [
  {
    label: "System Active Base",
    value: formatToCommaString(data.active_base),
    valueEligible: formatToCommaString(data.active_base),
  },
  {
    label: "Any Amount Active Merchant",
    value: formatToCommaString(data.any_active_count_this_month),
    subValue: calculateToPercentage(
      data.active_base,
      data.any_active_count_this_month
    ),

    valueEligible: formatToCommaString(
      data.any_active_count_this_month_eligible
    ),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.any_active_count_this_month_eligible
    ),
  },
  {
    label: "5 MAU 1500 Payment Merchant",
    value: formatToCommaString(data.green_active_count_this_month),
    subValue: calculateToPercentage(
      data.active_base,
      data.green_active_count_this_month
    ),

    valueEligible: formatToCommaString(
      data.green_active_count_this_month_eligible
    ),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.green_active_count_this_month_eligible
    ),
  },
  {
    label: (
      <>
        LMTD Transacting <br />
        vs Current Month Non-Transacting
      </>
    ),

    value: formatToCommaString(
      data.lmtd_last_month_this_month_transacting_compare
    ),
    subValue: calculateToPercentage(
      data.active_base,
      data.lmtd_last_month_this_month_transacting_compare
    ),

    valueEligible: formatToCommaString(
      data.lmtd_last_month_this_month_transacting_compare_eligible
    ),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.lmtd_last_month_this_month_transacting_compare_eligible
    ),
  },

  {
    label: (
      <>
        LMTD <br /> Any Amount Merchant
      </>
    ),

    value: formatToCommaString(data.lmtd_any_active_count),
    subValue: calculateToPercentage(
      data.active_base,
      data.lmtd_any_active_count
    ),

    valueEligible: formatToCommaString(data.lmtd_any_active_count_eligible),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.lmtd_any_active_count_eligible
    ),
  },

  {
    label: (
      <>
        LMTD
        <br /> 5 MAU 1500 Payment Merchantt
      </>
    ),
    value: formatToCommaString(data.lmtd_green_active_count),
    subValue: calculateToPercentage(
      data.active_base,
      data.lmtd_green_active_count
    ),

    valueEligible: formatToCommaString(data.lmtd_green_active_count_eligible),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.lmtd_green_active_count_eligible
    ),
  },

  {
    label: (
      <>
        Last Month Transacting vs
        <br /> Current Month Non-Transacting
      </>
    ),
    value: formatToCommaString(data.last_month_this_month_transacting_compare),
    subValue: calculateToPercentage(
      data.active_base,
      data.last_month_this_month_transacting_compare
    ),

    valueEligible: formatToCommaString(
      data.last_month_this_month_transacting_compare_eligible
    ),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.last_month_this_month_transacting_compare_eligible
    ),
  },
  {
    label: (
      <>
        Last Month
        <br /> Any Amount Merchant
      </>
    ),
    value: formatToCommaString(data.any_active_count_last_month),
    subValue: calculateToPercentage(
      data.active_base,
      data.any_active_count_last_month
    ),

    valueEligible: formatToCommaString(
      data.any_active_count_last_month_eligible
    ),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.any_active_count_last_month_eligible
    ),
  },
  {
    label: (
      <>
        Last Month <br />5 MAU 1500 Payment Merchant
      </>
    ),
    value: formatToCommaString(data.green_active_count_last_month),
    subValue: calculateToPercentage(
      data.active_base,
      data.green_active_count_last_month
    ),

    valueEligible: formatToCommaString(
      data.green_active_count_last_month_eligible
    ),
    subValueEligible: calculateToPercentage(
      data.active_base,
      data.green_active_count_last_month_eligible
    ),
  },
];

const useStyle = makeStyles((theme) => {
  return {
    card: { margin: theme.spacing(2, 0) },
    cardHeader: {
      borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
      paddingBottom: theme.spacing(1.5),
      marginTop: theme.spacing(0.5),
    },
    updateDate: {
      color: "rgba(54, 43, 115, 0.56)",
      margin: "0",
      fontSize: 12,
    },
    container: {
      display: "flex",
      width: "100%",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    widget: {
      background: "white",
      borderRadius: theme.spacing(1.5),
      margin: theme.spacing(1),
      width: "calc(33% - 16px)",
      padding: theme.spacing(2),
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      [theme.breakpoints.down("md")]: {
        width: "calc(50% - 16px)",
      },
    },
  };
});

export default function MerchantBaseOverview({ geoFilters }) {
  const params = useMemo(() => geoFilters, [geoFilters]);
  console.log(params);
  const { data, isLoading } = useFetch(
    "/reports/dashboard/merchant-overview",
    params
  );
  const [tabIndex, setTabIndex] = React.useState(0);
  const classes = useStyle();

  const tabConfig = [{ label: "Eligible" }, { label: "Overall" }];
  const onTabChange = (index) => {
    if (index == null) return;
    setTabIndex(index);
  };

  return (
    <DashboardWidgetCard className={classes.card}>
      <DashboardCardHeader
        className={classes.cardHeader}
        label="Merchant Base Overview"
        subLabel={
          data && (
            <p className={classes.updateDate}>
              Updated till - {formatDate(data.last_parsed_time)}
            </p>
          )
        }
      >
        <ToggleButtonsTrasnferList
          config={tabConfig}
          {...{ tabIndex, onTabChange }}
        />
      </DashboardCardHeader>

      {isLoading ? (
        <Loading />
      ) : (
        data && (
          <div className={classes.container}>
            {config(data).map((c, _i) => {
              return (
                <div className={classes.widget} key={_i}>
                  {tabConfig[tabIndex].label === "Eligible" ? (
                    <HeaderAndValue
                      {...c}
                      value={c.valueEligible}
                      subValue={c.subValueEligible}
                    />
                  ) : (
                    <HeaderAndValue {...c} />
                  )}
                </div>
              );
            })}
          </div>
        )
      )}
    </DashboardWidgetCard>
  );
}
